import { render, staticRenderFns } from "./error_szxq.vue?vue&type=template&id=1e7eea44&"
import script from "./error_szxq.vue?vue&type=script&lang=js&"
export * from "./error_szxq.vue?vue&type=script&lang=js&"
import style0 from "./error_szxq.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports